import styled, { css } from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { StepStatus } from '@/models/step.model';

const getStylesByStatus = (status?: string) => {
  switch (status) {
    case StepStatus.COMPLETED:
      return css`
        background: ${COLORS.GREEN_OLIVE};
        color: ${COLORS.DARK_GREEN_PALE};
      `;
    case StepStatus.IN_PROGRESS:
      return css`
        background: ${COLORS.YELLOW};
        color: ${COLORS.WHITE};
      `;
    default:
      return css`
        background: ${COLORS.GREY_FADED_A};
        color: ${COLORS.GREY_FADED};
      `;
  }
};

export const StyledTag = styled.div<{ $status?: string }>`
  padding: 0.25rem;
  border-radius: 0.25rem;
  width: fit-content;
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};

  ${({ $status }) => getStylesByStatus($status)}
`;
